import React from 'react';
import {Navbar} from 'react-bootstrap';
import SidebarToggle from "../sidebar/SidebarToggle";
import {injectIntl} from 'react-intl';
import i18n from "../../main/i18n";

export default injectIntl(props => {

  const msg = i18n.getMsg(props.intl);
  const customerName = msg(`customer.${process.env.REACT_APP_CUSTOMER}`);
  const appType = msg(`customer.${process.env.REACT_APP_CUSTOMER}.appType`);

  return (
    <Navbar fluid>
      <Navbar.Header>
        <Navbar.Brand>
          <h3>{customerName} {appType}</h3>
        </Navbar.Brand>
        <SidebarToggle/>
      </Navbar.Header>
    </Navbar>
  )
})
